import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

const sliderHomeProducts = document.getElementById('home-slider-products');

if (sliderHomeProducts) {
    new Swiper (sliderHomeProducts, {
        modules: [Navigation],
        grabCursor: true,
        slidesPerView: 2,
        spaceBetween: 24,
        breakpoints: {
            768: {
                slidesPerView: 3
            },
            1200: {
                slidesPerView: 4
            }
        },
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
        },
    });
}